import React from 'react';
import { IFlowThumbnail } from '~/types/model.types';
import { AnalyticsEvents } from '~/services/analytics/analytics-events';
import useAnalytics from '~/common/useAnalytics';
import ImageUpload from '~/common/ImageUpload/ImageUpload';
import { THUMBNAIL_CROP_RATIO } from '~/components/Builder/Configure/SetThumbnail/SetThumbnailPreview';
import { useGlobalMX } from '~/providers/mx-global-context/useGlobalMX';

interface Props {
    className?: string;
    customModalCssClass?: string;
    deleteThumbnail?: () => void;
    modalTitle?: string;
    onClickEditThumbnail?: () => void;
    setThumbnailImage: (thumbnail: IFlowThumbnail) => void;
    thumbnailImage: IFlowThumbnail | undefined;
}

const SetThumbnail = ({
    deleteThumbnail,
    modalTitle = 'Edit file thumbnail',
    onClickEditThumbnail,
    setThumbnailImage,
    thumbnailImage,
    className,
    customModalCssClass
}: Props) => {
    const {
        companyStore: { currCompany }
    } = useGlobalMX();

    const { track } = useAnalytics();

    const _setThumbnailImage = e => {
        track(AnalyticsEvents.FlowThumbnailEdit, {
            action: 'click',
            type: 'flow thumbnail'
        });
        setThumbnailImage(e);
    };

    const _deleteThumbnail = () => {
        track(AnalyticsEvents.FlowThumbnailDelete, {
            action: 'click',
            type: 'flow thumbnail'
        });
        deleteThumbnail?.();
    };

    return (
        <ImageUpload
            className={className}
            customModalCssClass={customModalCssClass}
            image={thumbnailImage}
            brandColor={currCompany.brand_color}
            icon={null}
            iconColor={null}
            backgroundColor={null}
            modalTitle={modalTitle}
            onDelete={_deleteThumbnail}
            onClickEdit={onClickEditThumbnail}
            setImage={_setThumbnailImage}
            aspectRatio={THUMBNAIL_CROP_RATIO}
        />
    );
};

export default SetThumbnail;
